<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-stepper v-model="e1">
				<v-stepper-header>
					<v-stepper-step :editable="e1 > 0" edit-icon="mdi-check" :complete="e1 > 1" step="1">
						المعلومات الأساسية
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step :editable="e1 > 0" edit-icon="mdi-check" :complete="e1 > 2" step="2">
						المقاسات والصور
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1">
						<v-form v-model="valid1">
							<v-row no-gutters justify="center">
								<v-col cols="12" class="pa-2">
									<v-text-field
										v-model="newRecord.title"
										outlined
										hide-details="auto"
										label="العنوان"
										:rules="[rules.required, rules.maxLength75]"
										counter="75"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-autocomplete
										v-model="newRecord.companyID"
										:items="companies"
										outlined
										hide-details="auto"
										label="الجهة المعلنة"
										item-text="name"
										item-value="id"
										:rules="[rules.required]"
									>
										<template #prepend-item>
											<v-list-item @click="showAddNewCompany = true">
												<v-list-item-title>إضافة جهة جديدة</v-list-item-title>
												<v-list-item-action>
													<v-icon>mdi-plus</v-icon>
												</v-list-item-action>
											</v-list-item>
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-autocomplete
										v-model="newRecord.rankID"
										:items="ranks"
										outlined
										hide-details="auto"
										label="رتبة الإعلان"
										item-text="name"
										item-value="adRankID"
										:rules="[rules.required]"
									>
										<template #item="{ item }">
											<v-list-item-content>
												<v-list-item-title>{{ item.name }}</v-list-item-title>
												<v-list-item-subtitle class="text-caption">
													<div v-if="item.topPriority">
														<b>
															احتمالية ظهور الإعلان العلوي {{ item.topPriority }} لكل {{ totalTop }}
															({{ Math.round(item.topPriority / totalTop * 100) }}%)
														</b>
													</div>
													<div v-if="item.rightPriority">
														احتمالية ظهور الإعلان الداخلي {{ item.rightPriority }} لكل {{ totalRight }}
														({{ Math.round(item.rightPriority / totalRight * 100) }}%)
													</div>
												</v-list-item-subtitle>
											</v-list-item-content>
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu1"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newRecord.startDate"
												outlined
												hide-details="auto"
												label="تاريخ بداية الإعلان"
												:rules="[rules.required]"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="newRecord.startDate"
											@input="menu1 = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu2"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newRecord.endDate"
												outlined
												hide-details="auto"
												label="تاريخ نهاية الإعلان"
												:rules="[rules.required, rules.endDateAfterStartDate(newRecord.startDate, newRecord.endDate)]"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="newRecord.endDate"
											@input="menu2 = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-text-field
										v-model="newRecord.adLink"
										outlined
										hide-details="auto"
										label="رابط الإعلان"
										:rules="[rules.required]"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-textarea
										v-model="newRecord.description"
										:rows="3"
										outlined
										hide-details="auto"
										label="التفاصيل"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-textarea>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-textarea
										v-model="newRecord.note"
										:rows="3"
										outlined
										hide-details="auto"
										label="الملاحظات"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-textarea>
								</v-col>

								<v-col cols="12" class="pa-2 text-center" order="3">
									<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="submitStep1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-form v-model="valid2">
							<v-row no-gutters>
								<v-col cols="12" class="pa-2">
									<v-autocomplete
										v-model="selectedSizes"
										outlined
										hide-details="auto"
										label="المقاسات المطلوبة"
										:items="photoSizes"
										chips
										small-chips
										multiple
										item-text="photoSizeID"
										return-object
										:disabled="loading"
										:item-disabled="disablingFunction"
									></v-autocomplete>
								</v-col>
								<v-col cols="12" class="pb-5 pt-2 px-2">
									<v-row dense>
										<v-col
											v-for="size in selectedSizes"
											:key="size.photoSizeID"
											cols="12"
											md="6"
											class="text-center"
										>
											<v-file-input
												v-model="size.image"
												:label="'انقر لإضافة الإعلان لمقاس ' + size.photoSizeID"
												hide-details
												outlined
												:rules="[rules.required]"
												prepend-icon
												show-size
												:disabled="loading"
											></v-file-input>
											<br />
											<v-img
												contain
												:src="size.image | imgToURL"
												:aspect-ratio="size.width/size.hight"
												:max-height="size.hight"
												:max-width="size.width"
												style="border: 1px dotted grey"
												class="mx-auto"
											></v-img>
											<v-alert :type="size.state" :value="size.state">{{ size.state }}</v-alert>
										</v-col>
									</v-row>
								</v-col>

								<v-col v-if="isEdit" cols="12" class="pb-5 pt-2 px-2">
									<div>صور الإعلانات السابقة</div>
									<v-row dense>
										<v-col
											v-for="photo in newRecord.adPhotoes"
											:key="photo.photoSizeID"
											cols="12"
											md="6"
											class="text-center"
										>
											<v-img
												contain
												:src="photo.adPhoto"
												:aspect-ratio="photo.width/photo.hight"
												:max-height="photo.hight"
												:max-width="photo.width"
												style="border: 1px dotted grey"
												class="mx-auto"
											>
												<template #default>
													<v-row class="fill-height ma-0">
														<v-tooltip bottom>
															<template #activator="{ on }">
																<v-btn icon color="primary" v-on="on" @click="showImageUpdate(photo)">
																	<v-icon>mdi-image-edit</v-icon>
																</v-btn>
															</template>
															<span>تحرير</span>
														</v-tooltip>

														<v-spacer></v-spacer>

														<v-chip class="ma-1">{{ photo.width + 'x' + photo.hight }}</v-chip>
													</v-row>
												</template>
											</v-img>
										</v-col>
									</v-row>
								</v-col>
								
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="(!valid2 || selectedSizes.length == 0) && !isEdit" :loading="loading" @click="submitStep2">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>

		<v-dialog v-model="showAddNewCompany" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة شركة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="addCompanyForm" v-model="valid3">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newCompany.name"
									outlined
									label="اسم الجهة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover=";">
								<v-btn color="primary" :disabled="!valid3" :loading="loading" @click="addnewCompany">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="updateImageDialog" width="500">
			<v-card v-if="oldPhoto">
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>
						تحديث صورة الإعلان لمقاس {{ oldPhoto.photoSizeID }}
					</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid4">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-file-input
									v-model="newImage"
									label="الصورة الجديدة"
									hide-details
									outlined
									:rules="[rules.required]"
									prepend-icon
									show-size
									:disabled="loading"
								></v-file-input>
								<br />
								<v-img
									contain
									:src="newImage | imgToURL"
									:aspect-ratio="oldPhoto.width/oldPhoto.hight"
									:max-height="oldPhoto.hight"
									:max-width="oldPhoto.width"
									style="border: 1px dotted grey"
									class="mx-auto"
								></v-img>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover=";">
								<v-btn color="primary" :disabled="!valid4" :loading="loading" @click="saveImage">
									تحديث
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الإعلانات', to: { name: "dashboard-ads" }, exact: true },
				{ text: 'إضافة إعلان', disabled: true }
			],
			loading: false,
			e1: 1,
			newRecord: {
				title: "",
				companyID: null,
				rankID: null,
				startDate: null,
				endDate: null,
				note: "",
				description: "",
				adLink: null,
				adPhotoes: []
			},
			specialties: [],
			selectedSizes: [],
			recordID: 2,
			companies: [],
			ranks: [],
			photoSizes: [],
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			menu1: false,
			menu2: false,
			totalTop: 0,
			totalRight: 0,
			showAddNewCompany: false,
			newCompany: {},
			isEdit: false,
			isAdded: false,
			oldPhoto: null,
			updateImageDialog: false,
			newImage: null
		};
	},
	mounted() {
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.recordID = this.$route.params.recordID;
			this.breadcrumbs[2].text = "التعديل";
			this.getPreviousInfo();
		} else {
			console.log("not edit");
		}

		this.getCompanies();
		this.getRanks();
		this.getPhotoSizes();
	},
	methods: {
		getPreviousInfo() {
			client
				.get("/api/unspokenname/show/" + this.recordID)
				.then(response => {
					console.log(response);
					var newData = response.data.data;
					this.newRecord = newData;
					this.newRecord.rankID = newData.adRankID
					this.newRecord.adPhotoes = newData.adPhotoes.map(photo => {
						const dimensions = photo.photoSizeID.split("x")
						photo.width = dimensions[0]
						photo.hight = dimensions[1]
						return photo;
					})
					setTimeout(() => {
						// on next tick, 0ms is enough
						this.valid1 = true;
					}, 100);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRanks() {
			client
				.get("/api/unspokenname/adranks")
				.then(response => {
					this.ranks = response.data.sort(
						(a, b) => a.priority - b.priority
					);

					this.totalTop = this.ranks
						.map(r => r.topPriority)
						.reduce((a, b) => a + b, 0);
					this.totalRight = this.ranks
						.map(r => r.rightPriority)
						.reduce((a, b) => a + b, 0);

					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPhotoSizes() {
			client
				.get("/api/unspokenname/photosizes")
				.then(response => {
					this.photoSizes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCompanies() {
			client
				.get("/api/companies/all")
				.then(response => {
					this.companies = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitStep1() {
			this.loading = true;
			var link = "/api/unspokenname/insert";
			if (this.added || this.isEdit) {
				link = "/api/unspokenname/update";
				this.newRecord.adID = this.recordID
			}

			clientNotifier
				.post(link, this.newRecord)
				.then(response => {
					this.e1 = 2;
					this.added = true;
					this.recordID = response.data.data.id;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(()=>{
					this.loading = false;
				})
		},
		submitStep2() {
			this.loading = true;
			var success = 0;
			var failed = 0;
			if(this.selectedSizes.length == 0){
				this.$router.push({
					name: "dashboard-ads-manage"
				});
			} else {
				this.selectedSizes.forEach(size => {
					var data = new FormData();
					data.append("adID", this.recordID);
					data.append("photoSizeID", size.photoSizeID);
					data.append("attachment", size.image);

					let config = {
						headers: {
							"Content-Type":
								"multipart/form-data; boundary=something"
						}
					};

					client
						.post("/api/unspokenname/insertphoto", data, config)
						.then(response => {
							console.log(response);
							success++;
							size.state = "success";

							if (success + failed == this.selectedSizes.length) {
								console.log(success, failed);
								this.loading = false;
								if (failed == 0) {
									this.$store.dispatch("notify", {
										message: "تم حفظ جميع الصور"
									});

									this.$router.push({
										name: "dashboard-ads-manage"
									});
								}
							}
						})
						.catch(err => {
							console.log(err);
							failed++;

							size.state = "error";

							if (success + failed == this.selectedSizes.length) {
								if (success == 0) {
									this.$store.dispatch("notify", {
										message: "لم يتم حفظ " + failed,
										color: "error"
									});
								} else {
									this.$store.dispatch("notify", {
										message:
											"تم حفظ " +
											success +
											" ولم يتم حفظ " +
											failed,
										color: "error"
									});
								}
								console.log(success, failed);
								this.loading = false;
							}
						});
				});
			}
		},
		addnewCompany() {
			this.loading = true;
			var data = {
				...this.newCompany
			};
			clientNotifier
				.post("/api/companies/new", data)
				.then(response => {
					this.companies.push({
						name: this.newCompany.name,
						id: response.data.data.id
					});
					this.newRecord.companyID = response.data.data.id;
					this.showAddNewCompany = false;
					this.newCompany = {
						name: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		disablingFunction(item){
			if(this.newRecord.adPhotoes.length == 0){
				return false;
			}

			const sizes = this.newRecord.adPhotoes.map(photo => photo.photoSizeID);
			return sizes.includes(item.photoSizeID);
		},
		showImageUpdate(photo){
			this.oldPhoto = {...photo};
			this.updateImageDialog = true;
		},
		saveImage(){
			this.loading = true;
			var data = new FormData();
			data.append("adID", this.recordID);
			data.append("photoSizeID", this.oldPhoto.photoSizeID);
			data.append("attachment", this.newImage);

			let config = {
				headers: {
					"Content-Type":
						"multipart/form-data; boundary=something"
				}
			};

			clientNotifier
				.post("/api/unspokenname/replacePhoto", data, config)
				.then(response => {
					console.log(response);
					this.showImageUpdate = false;
					this.newImage = null;
				})
				.finally(()=>{
					this.loading = false;
				})
		}
	}
};
</script>

<style scoped>
.ltr-content ::v-deep input {
	direction: ltr;
}
</style>